import React, { useState } from 'react';
import { FaLinkedin, FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import Nav from '../Nav';
import Navbar from '../Navbar';
import Footer from '../Footer/Footer';
import { Popup } from './Popup';
import Row2 from './Row2';
import S1 from '../assets/Speakers/rose_ngugi.png';
import Default from '../assets/Speakers/kipDefault.png';
import Default1 from '../assets/Speakers/logo.png';


const speakersData = [
    {
        name: 'Dr. Rose Ngugi',
        image: S1,
        description: 'Executive Director KIPPRA',
        fulldec: (
          <>
            <p>Dr. Rose Ngugi is the Executive Director of the Kenya Institute for Public Policy Research and Analysis (KIPPRA) and serves as the Secretary to the Board.</p><br />
            <p>She is involved in providing technical guidance and capacity building on policy and strategy formulation to the Government of Kenya and other stakeholders, with the overall aim of contributing to the achievement of national development goals. Before then, she was a Senior Advisor in the Office of Executive Director, Africa Group 1, International Monetary Fund, and Washington D.C.</p><br />
            <p>Dr. Ngugi has been a member of Central Bank of Kenya, Monetary Policy Committee and has vast teaching experience in the University of Nairobi, School of Economics.</p><br />
            <p>Dr Ngugi has published widely. Her research interests are in public policy, financial sector, investments, reforms and institutional issues. She holds a PhD from Business School Birmingham University, UK specializing in Financial Markets, a Masters and Bachelors degree in Economics from the University of Nairobi, Kenya.</p><br />
          </>
        ),
        social: {
          linkedin: 'https://www.linkedin.com/company/kippra/mycompany/',
          facebook: 'https://www.facebook.com/KIPPRAKENYA/',
          instagram: 'https://www.instagram.com/KIPPRAKENYA/',
          twitter: 'https://twitter.com/KIPPRAKENYA',
        },
      },
      
  // ...rest of the speakers
  {
    name: 'Speaker 2',
    image: Default,
    description: 'Description for Speaker 2',
    social: {
      social: {
        linkedin: 'https://www.linkedin.com/company/kippra/mycompany/',
        facebook: 'https://www.facebook.com/KIPPRAKENYA/',
        instagram: 'https://www.instagram.com/KIPPRAKENYA/',
        twitter: 'https://twitter.com/KIPPRAKENYA',
      },
      },
  },
  {
    name: 'Speaker 3',
    image: Default1,
    description: 'Description for Speaker 3',
    social: {
      linkedin: 'https://www.linkedin.com/company/kippra/mycompany/',
      facebook: 'https://www.facebook.com/KIPPRAKENYA/',
      instagram: 'https://www.instagram.com/KIPPRAKENYA/',
      twitter: 'https://twitter.com/KIPPRAKENYA',
    },
  },

];

const Speaker = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  
    const handleCardClick = (speaker) => {
      setSelectedSpeaker(speaker);
      setIsPopupOpen(true);
    };
  
    const handleClosePopup = () => {
      setIsPopupOpen(false);
      setSelectedSpeaker(null);
    };
  
    return (
      <div>
        <Nav />
        <Navbar />
        <div className="flex flex-wrap justify-center" style={{ marginTop: '100px' }}>
          {speakersData.map((speaker, index) => (
            <div
              key={index}
              className="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-2 cursor-pointer transform transition duration-300 hover:scale-105"
              onClick={() => handleCardClick(speaker)}
            >
              <div className="max-w-sm rounded overflow-hidden shadow-lg m-auto hover:bg-green-500">
              <img
                className="w-full h-64 object-cover"
                src={speaker.image}
                alt={speaker.name}
              />
                <div className="px-6 py-4">
                  <div className="font-bold text-xl mb-2">{speaker.name}</div>
                  <p className="text-gray-700 text-base">{speaker.description}</p>
                  <div className="mt-4 flex justify-center">
                    <a
                      href={speaker.social.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-2"
                    >
                      <FaLinkedin size={24} />
                    </a>
                    <a
                      href={speaker.social.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-2"
                    >
                      <FaFacebook size={24} />
                    </a>
                    <a
                      href={speaker.social.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-2"
                    >
                      <FaInstagram size={24} />
                    </a>
                    <a
                      href={speaker.social.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-2"
                    >
                      <FaTwitter size={24} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {isPopupOpen && (
          <Popup speaker={selectedSpeaker} onClose={handleClosePopup} />
        )}
        <div>
          <Row2 />
        </div>
        <div className="mt-2">
          <Footer />
        </div>
      </div>
    );
  };
  
  export default Speaker;
  